import { ReactNode } from 'react';
import styles from 'components/styles/Table.module.scss';
import cn from 'classnames';
import LinkIf from './LinkIf';
import { useApplicationContainer } from 'containers/ApplicationContainer';

interface TableProps {
  className?: string;
  children: ReactNode;
  noBottomBorder?: boolean;
  reducedPadding?: boolean;
  regularMargin?: boolean;
  v2?: boolean;
}

export const Table = ({ children, className, noBottomBorder, reducedPadding, regularMargin, v2 }: TableProps) => {
  return (
    <div
      className={cn(styles.SBLTable, className, {
        [styles.SBLTableBottomBorderless]: noBottomBorder,
        [styles.TableReducedPadding]: reducedPadding,
        [styles.RegularMargin]: regularMargin,
        [styles.TableV2]: v2
      })}
    >
      <table>{children}</table>
    </div>
  );
};

interface TableHeadProps {
  headers: string[];
  children?: ReactNode;
}

export const TableHead = ({ headers, children, ...otherProps }: TableHeadProps) => (
  <thead {...otherProps}>
    <tr>
      <th />
      {children}
      {headers.map((header, i) => (
        <th key={i} className={`th-${header}`}>
          {header}
        </th>
      ))}
      <th />
    </tr>
  </thead>
);

interface TableBodyProps {
  children: ReactNode;
}

export const TableBody = ({ children }: TableBodyProps) => <tbody>{children}</tbody>;

interface TableRowProps {
  className?: string;
  children: ReactNode;
  [key: string]: any;
}

export const TableRow = ({ children, className, ...props }: TableRowProps) => (
  <tr className={className} {...props}>
    <td />
    {children}
    <td />
  </tr>
);

interface TableRowLinkProps extends TableRowProps {
  href?: string;
}

export const TableRowLink = ({ children, className, href, ...props }: TableRowLinkProps) => {
  const [, { handleOpenLink }] = useApplicationContainer();

  return (
    <tr
      className={cn(styles.TableRowLink, className)}
      {...props}
      onClick={event => {
        const targetElement = event.target as Element;
        if (href != null && !targetElement.closest('a')) {
          handleOpenLink(href);
        }
      }}
    >
      <td />
      {children}
      <td />
    </tr>
  );
};
